exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbar-brand img{\r\n    max-width: 400px;\r\n}\r\n\r\n.navbar-collapse{\r\n    margin-bottom: 7px;\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n    .navbar-collapse{\r\n        background-color: rgba(0, 0, 0, 0.30);\r\n    }    \r\n\r\n    .navbar{\r\n        padding-left: 0px;\r\n        padding-right: 0px;\r\n    }\r\n\r\n    .container-navbar{\r\n        padding-left: 0px;\r\n        padding-right: 0px;\r\n    }\r\n\r\n    .navbar-toggler{\r\n        margin-right: 15px;\r\n        margin-bottom: 7px;\r\n    }\r\n}\r\n\r\n@media screen and (min-width: 280px) and (max-width: 430px){\r\n    \r\n\r\n    .navbar-brand{\r\n        max-width: 70% !important;\r\n    }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Front-end/[PROYECTO] abordo-empresarial-cli4/[RAMA] actualizarAngular-Analytics/abordo-empresarial-cli4/src/app/componentes/header/header.component.css
// module id = ../../../../../src/app/componentes/header/header.component.css
// module chunks = 1